import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Input from 'epic-diesel-form/src/components/form/Input';
import Select from 'epic-diesel-form/src/components/form/Select';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import {Button, buttonTypes, priority} from 'epic-diesel-common/src';
import Countries from 'epic-diesel-form/src/constants/Countries';
import moment from 'moment';
import {statesFullNames, canadaProvinces, australiaStates} from '../../constants/Countries';
import styles from './Tax.pcss';
import Message, {getMessage} from '../common/Message';
// import MaskedInputField from '../form/MaskedInputField';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';

import TaxRecordStatusCodes from '../../constants/TaxRecordStatus';

const STATE_SELECT_RC = ['US', 'CA', 'AU'];

const TaxRecordProfile = ({messages, taxRecord = {}, onOpen, updateRecord, validated, retakeAvailable}) => {
    const taxInfoSchema = getInfluencersFlowSchema(getMessage, messages).taxInfo;
    const [taxRecordProfile, setTaxRecordProfile] = useState({});

    const reset = () => {
        setTaxRecordProfile(taxRecord);
    };

    useEffect(() => {
        setTaxRecordProfile(taxRecord);
    }, []);

    const privacyPolicyLink = 'https://www.epicgames.com/site/en-US/privacypolicy';
    const _desc = getMessage(messages, 'epic.affiliate.settings.tax.profile.desc.verified', [
        privacyPolicyLink
    ]);
    const trigger = (name, value) => {
        const newState = {
            ...taxRecordProfile,
            [name]: value
        };
        setTaxRecordProfile(newState);
    };

    const onChange = e => {
        const {name, value} = e.target;
        trigger(name, value);
    };

    const onRetake = () => onOpen();

    const onSaveRecord = model => {
        updateRecord(taxRecordProfile);
    };

    const StatusBar = () => {
        const statusStyles = validated ? styles.taxValidated : styles.taxInValidated;
        return <b className={statusStyles}>{getMessage(messages, TaxRecordStatusCodes[taxRecordProfile.taxStatus])}</b>;
    };
    const elapsedYears = moment().diff(taxRecord.dateOfBirth, 'years');

    const isStateSelected = STATE_SELECT_RC.includes(taxRecord.addressCountryCode);
    let stateList = [];
    if (isStateSelected) {
        switch (taxRecord.addressCountryCode) {
            case 'US': {
                stateList = statesFullNames;
                break;
            }
            case 'CA':
                stateList = canadaProvinces;
                break;
            case 'AU':
                stateList = australiaStates;
                break;
            default:
                stateList = null;
        }
    }

    return <>
        <div key="tax" className={styles.section}>
            <FormsyForm submitForm={onSaveRecord}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.tax_title"/>
                    <StatusBar/>
                </div>
                <div className={styles.desc}>
                    <p dangerouslySetInnerHTML={{__html: _desc}}/>
                </div>

                <div className={styles.row}>
                    <div className={styles.fullSection}>
                        <Input
                            name={taxInfoSchema.organizationId.identifier}
                            value={taxRecordProfile.identityId}
                            required={false}
                            disabled={true}
                            placeholder={`${
                                !taxRecordProfile.organizationEntity
                                    ? taxInfoSchema.accountId.display.text
                                    : taxInfoSchema.organizationId.display.text
                            }`}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.businessType.identifier}
                            value={`${
                                !taxRecordProfile.organizationEntity ? 'Individual' : 'Business'
                            }`}
                            required={false}
                            disabled={true}
                            placeholder={taxInfoSchema.businessType.display.text}
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.recordIdentityKey.identifier}
                            value={taxRecordProfile.tin}
                            placeholder={taxInfoSchema.recordIdentityKey.display.text}
                            messages={messages}
                            disabled={true}
                            required={false}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    {
                        !taxRecordProfile.organizationEntity && <>
                            <div>
                                <Input
                                    name={taxInfoSchema.firstName.identifier}
                                    value={taxRecordProfile.firstName}
                                    disabled={true}
                                    placeholder={taxInfoSchema.firstName.display.text}
                                />
                            </div>
                            <span />
                            <div>
                                <Input
                                    name={taxInfoSchema.lastName.identifier}
                                    value={taxRecordProfile.lastName}
                                    disabled={true}
                                    placeholder={taxInfoSchema.lastName.display.text}
                                />
                            </div>
                        </>
                    }
                </div>

                <Button type={buttonTypes.SUBMIT} onClick={onRetake} disabled={!retakeAvailable} priority={priority.PRIMARY} theme="dark">
                    <Message code="epic.affiliate.common.submit.retake" />
                </Button>
            </FormsyForm>
        </div>
        {!taxRecordProfile.organizationEntity && (elapsedYears < 18) && <div key="guardian" className={styles.section}>
            <div className={styles.title}>
                <Message code="epic.affiliate.form.tax.guardian.title"/>
            </div>
            <FormsyForm submitForm={onSaveRecord}>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.guardianEmail.identifier}
                            value={taxRecordProfile.guardianEmail}
                            onChange={onChange}
                            validations={taxInfoSchema.guardianEmail.validations}
                            validationErrors={taxInfoSchema.guardianEmail.validationMessages}
                            placeholder={taxInfoSchema.guardianEmail.display.text}
                            required
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.guardianPhoneNumber.identifier}
                            value={taxRecordProfile.guardianPhoneNumber}
                            validations={taxInfoSchema.guardianPhoneNumber.validations}
                            validationErrors={taxInfoSchema.guardianPhoneNumber.validationMessages}
                            onChange={onChange}
                            placeholder={taxInfoSchema.guardianPhoneNumber.display.text}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.guardianFirstName.identifier}
                            onChange={onChange}
                            validations={taxInfoSchema.guardianFirstName.validations}
                            validationErrors={taxInfoSchema.guardianFirstName.validationMessages}
                            value={taxRecordProfile.guardianFirstName}
                            placeholder={taxInfoSchema.guardianFirstName.display.text}
                            required
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.guardianLastName.identifier}
                            onChange={onChange}
                            validations={taxInfoSchema.guardianLastName.validations}
                            validationErrors={taxInfoSchema.guardianLastName.validationMessages}
                            value={taxRecordProfile.guardianLastName}
                            placeholder={taxInfoSchema.guardianLastName.display.text}
                            required
                        />
                    </div>
                </div>
                <Button type={buttonTypes.SUBMIT} priority={priority.PRIMARY} theme="dark">
                    <Message code="epic.affiliate.common.submit.save"/>
                </Button>
                <Button onClick={reset} priority={priority.SECONDARY} theme="gray">
                    <Message code="epic.affiliate.common.submit.discard"/>
                </Button>
            </FormsyForm>
        </div>}

        <div key="address" className={styles.section}>
            <FormsyForm submitForm={onSaveRecord}>
                <div className={styles.title}>
                    <Message code="label.affiliate.form.tax.contact"/>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.email.identifier}
                            onChange={onChange}
                            disabled={!taxRecordProfile.organizationEntity}
                            value={taxRecordProfile.email}
                            placeholder={taxInfoSchema.email.display.text}
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.phoneNumber.identifier}
                            required={true}
                            onChange={onChange}
                            isRequired={true}
                            validations={taxInfoSchema.phoneNumber.validations}
                            validationErrors={taxInfoSchema.phoneNumber.validationMessages}
                            value={taxRecordProfile.phoneNumber}
                            text={taxInfoSchema.phoneNumber.display.text}
                            placeholder={taxInfoSchema.phoneNumber.display.text}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.addressLine1.identifier}
                            required={false}
                            onChange={onChange}
                            value={taxRecordProfile.addressLine1}
                            placeholder={taxInfoSchema.addressLine1.display.text}
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.addressLine2.identifier}
                            required={false}
                            onChange={onChange}
                            value={taxRecordProfile.addressLine2}
                            placeholder={taxInfoSchema.addressLine2.display.text}
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.addressCity.identifier}
                            required={false}
                            onChange={onChange}
                            value={taxRecordProfile.addressCity}
                            placeholder={taxInfoSchema.addressCity.display.text}
                        />
                    </div>
                    <span />
                    <div>
                        {
                            isStateSelected ?
                                <Select
                                    name={taxInfoSchema.addressState.identifier}
                                    value={taxRecordProfile.addressState}
                                    validationErrors={taxInfoSchema.addressState.validationMessages}
                                    options={stateList}
                                    onChange={trigger}
                                /> : <Input
                                    required={false}
                                    name={taxInfoSchema.addressState.identifier}
                                    onChange={onChange}
                                    value={taxRecordProfile.addressState}
                                    validationErrors={taxInfoSchema.addressState.validationMessages}
                                    placeholder={taxInfoSchema.addressState.display.text}
                                />
                        }
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={taxInfoSchema.addressPostCode.identifier}
                            required={false}
                            onChange={onChange}
                            value={taxRecordProfile.addressPostCode}
                            placeholder={taxInfoSchema.addressPostCode.display.text}
                        />
                    </div>
                    <span />
                    <div>
                        <Input
                            name={taxInfoSchema.addressCountryCode.identifier}
                            options={Countries}
                            disabled={true}
                            value={taxRecordProfile.addressCountryCode}
                            placeholder={taxInfoSchema.addressCountryCode.display.text}
                        />
                    </div>
                </div>
                <Button type={buttonTypes.SUBMIT} priority={priority.PRIMARY} theme="dark">
                    <Message code="epic.affiliate.common.submit.save"/>
                </Button>
                <Button onClick={reset} priority={priority.SECONDARY} theme="gray">
                    <Message code="epic.affiliate.common.submit.discard"/>
                </Button>
            </FormsyForm>
        </div>
    </>;
};

TaxRecordProfile.propTypes = {
    messages: PropTypes.object,
    taxRecord: PropTypes.object,
    updateRecord: PropTypes.func,
    refreshRecord: PropTypes.func,
    validated: PropTypes.bool,
    retakeAvailable: PropTypes.bool,
    syncAvailable: PropTypes.bool,
    consentForPayment: PropTypes.func,
    isConsent: PropTypes.bool,
    onOpen: PropTypes.func
};

export default TaxRecordProfile;
